import React from 'react'
import { Box, Skeleton } from '@mui/material'
import { StyledWidgetGlobalPrice } from '../WidgetGlobalPrice.styles'

const WidgetGlobalPriceSkeleton = () => (
  <StyledWidgetGlobalPrice>
    <Skeleton variant="circular" width={58} height={58} animation="wave" sx={{ borderRadius: 1, bgcolor: '#EFEFEF', mb: 3 }} />
    <Box width="100%" display="flex" justifyContent="center">
      <Box width="80%">
        <Skeleton variant="text" width="60%" height={24} animation="wave" sx={{ borderRadius: 1, bgcolor: '#EFEFEF' }} />
        <Skeleton variant="text" width="80%" height={34} animation="wave" sx={{ borderRadius: 1, bgcolor: '#EFEFEF' }} />
      </Box>
    </Box>
  </StyledWidgetGlobalPrice>
)

export default WidgetGlobalPriceSkeleton
